/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Confirm1Inputs */

const vi_driverremittance_confirm1 = /** @type {(inputs: Driverremittance_Confirm1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đã nhận`)
};

/**

* @param {Driverremittance_Confirm1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_confirm1 = /** @type {((inputs?: Driverremittance_Confirm1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Confirm1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_confirm1(inputs)
});
export { driverremittance_confirm1 as "driverRemittance_confirm" }